export const backgroundGradientSvgString = `
<svg width="2500" height="254" viewBox="0 0 2500 254" fill="none" xmlns="http://www.w3.org/2000/svg" class="min-w-[2500px]">
  <g clip-path="url(#clip0_9702_14080)">
    <rect width="2500" height="254" fill="#F7FAFF" />
    <g filter="url(#filter0_f_9702_14080)">
      <circle cx="1811" cy="919" r="759" fill="#D2E9F7" />
    </g>
    <rect width="2500" height="160" fill="url(#paint0_linear_9702_14080)" />
  </g>
  <defs>
    <filter id="filter0_f_9702_14080" x="507.535" y="-384.465" width="2606.93" height="2606.93" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur stdDeviation="272.232" result="effect1_foregroundBlur_9702_14080" />
    </filter>
    <linearGradient id="paint0_linear_9702_14080" x1="1250" y1="0" x2="1250" y2="160" gradientUnits="userSpaceOnUse">
      <stop stop-color="white" />
      <stop offset="1" stop-color="white" stop-opacity="0" />
    </linearGradient>
    <clipPath id="clip0_9702_14080">
      <rect width="2500" height="254" fill="white" />
    </clipPath>
  </defs>
</svg>
`;
